import React from "react";
import { useNavigate } from "react-router";
import { Col, Row } from "react-bootstrap";
import LootLedgerLogo from "../../assets/images/lootLedgerLogo.svg";
import { Button, SimpleInputTextField } from "../../shared/components";
import { buttonNameConstants, routesPathConstants } from "../../constants";
import { ReactComponent as ShopifyLogo } from "../../assets/images/shopifyLogo.svg";
import { LinkIcon } from "../../assets/icons/iconsProvider";

const ShopifyAppInstall = () => {
  const navigate = useNavigate();

  return (
    <Row className="vh-100 d-flex justify-content-center align-items-center">
      <Col
        md={12}
        className="m-auto d-flex justify-content-center align-items-center"
      >
        <Col
          lg={4}
          className="m-auto d-flex flex-column gap-3 billing-card-wrapper"
        >
          <div className="w-md-50 m-auto d-flex gap-4 justify-content-center align-items-center">
            <img
              src={LootLedgerLogo}
              alt="loot-ledger-logo"
              className="loot-ledger-footer-logo"
            />
            {/* <LinkIcon className="mx-auto" width={24} height={24} />
            <ShopifyLogo className="mx-auto" width={128} /> */}
          </div>
          <p>
            Please contact administration to install the app or sign in if you
            already have an account with LootLedger.
          </p>
          <Button
            type="button"
            className={"w-100 mt-0"}
            handleClick={() => {
              navigate(routesPathConstants.LOGIN);
            }}
            label={buttonNameConstants.LOGIN}
          />
        </Col>
      </Col>
    </Row>
  );
};

export default ShopifyAppInstall;
